import { useQuery } from "react-query";
import { getAdminActiveAadeCases } from "src/aadeCase/data-access/gateway";
import { MRT_PaginationState } from "material-react-table";
import React from "react";

function useGetAdminActiveAadeCases({
  searchFilters,
  enableSearch,
  setEnableSearch,
  paginationState,
}: {
  searchFilters: Object;
  enableSearch: Boolean;
  setEnableSearch: React.Dispatch<React.SetStateAction<Boolean>>;
  paginationState: MRT_PaginationState;
}) {
  return useQuery({
    queryFn: () => getAdminActiveAadeCases(searchFilters, paginationState),
    queryKey: ["getAdminActiveAadeCases", searchFilters, paginationState],
    onSettled: () => {
      setEnableSearch(false);
    },
    enabled: !!enableSearch,
  });
}

export default useGetAdminActiveAadeCases;
